import { useLocation, useNavigate } from 'react-router-dom';
import Routes from '../../../../../constants/routes';

type UseAddToCartSuccessReturn = () => void;

const useAddToCartSuccess = (): UseAddToCartSuccessReturn => {
    const navigate = useNavigate();
    const location = useLocation();

    return (): void => {
        const isCartPage = location.pathname === Routes.WARENKORB.path;

        !isCartPage && navigate(Routes.WARENKORB.path);
    };
};

export default useAddToCartSuccess;
